/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentDetail } from '../../models/content-detail';
import { CreateUpdateContentRequest } from '../../models/create-update-content-request';

export interface UpdateContentVersion$Params {

/**
 * ID stránky
 */
  id: number;

/**
 * ID verzie
 */
  versionId: number;
      body?: CreateUpdateContentRequest
}

export function updateContentVersion(http: HttpClient, rootUrl: string, params: UpdateContentVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentDetail>> {
  const rb = new RequestBuilder(rootUrl, updateContentVersion.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('versionId', params.versionId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentDetail>;
    })
  );
}

updateContentVersion.PATH = '/admin/content/{id}/version/{versionId}';
